<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            Mbeshtetur nga Arkit
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
       
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
